import { createSlice } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";

const initialState = {};

export const persistConfig = {
  storage: storage,
  key: "root",
};

const tabsSlice = createSlice({
  name: "tabs",
  initialState,
  reducers: {},
});

export const { _ } = tabsSlice.actions;

export default tabsSlice.reducer;
